import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionMenuContentComponent } from './permission-menu-content.component';

/**
 * Abre a sidebar de permissões (FAB) delegando a lógica a {@link PermissionMenuContentComponent}.
 */
@Component({
  selector: 'mm-permission-menu',
  templateUrl: './permission-menu.component.html',
  styleUrls: ['./permission-menu.component.scss']
})
export class PermissionMenuComponent {
  @Input('homepageId') homepageId: string;
  @Input('pageId') pageId: string;
  @Input() type: string;
  @Input() config: unknown;
  @Input() id: string;
  @Input('menu-id') menuId: string;
  @Output() close = new EventEmitter();
  @Output('updateList') updateListEmitter = new EventEmitter<unknown>();
}
